import { MutableRefObject, useEffect, useState } from 'react'

const useInView = <T extends Element>(
  target: MutableRefObject<T | null>,
  options: IntersectionObserverInit = {},
  enabled = true
) => {
  const [isIntersecting, setIsIntersecting] = useState(false)

  useEffect(() => {
    if (!enabled) return

    const el = target.current
    if (!el) return

    const observer = new IntersectionObserver((entries) => {
      setIsIntersecting(entries[0].isIntersecting)
    }, options)

    observer.observe(el)
    return () => observer.disconnect()
  }, [target, enabled, options.root, options.rootMargin, options.threshold])

  return isIntersecting
}

export default useInView
